import React, { FC, useState } from 'react'
import s from '@pages/auth/authPage.module.scss'
import { useTranslation } from '@hooks/useTranslation'
import cn from 'classnames'
import { TabItems } from '@components/Pages/AuthPage/TabItems'
import { useRouter } from 'next/router'
import { LinksEnum } from '@specs/navigation'
import { Input } from '@components/UIKit/Input/Input'
import { isEmailValid } from '@helpers/helpers'
import { Button } from '@components/UIKit/Button/Button'
import { Checkbox } from '@components/UIKit/Checkbox/Checkbox'
import { FormattedMessage } from 'react-intl'
import Link from 'next/link'
import { Socials } from '@components/Pages/AuthPage/Socials/Socials'


export type TabType = 'login' | 'register'

interface Props {
    emailHandler: () => void
    setEmail: React.Dispatch<React.SetStateAction<string>>
    email: string
}

export const AuthVariants: FC<Props> = ({ emailHandler, email, setEmail }) => {
    const router = useRouter()
    const { translate: tr } = useTranslation()
    const [valid, setValid] = useState<boolean | 'default'>('default')
    const [isChecked, setIsChecked] = useState(true)

    const changeEmailHandler = (value: string) => {
        setEmail(value)
        if (value.trim() === '') return setValid('default')
        setValid(isEmailValid(value))
    }

    const supportHandler = () => {
        window.open(LinksEnum.SUPPORT, '_blank', 'noreferrer')
    }


    return (
        <>
            <h1 className={cn(
                s.authPage__title,
                '_title',
            )}>
                {tr({ id: 'auth.page.title' })}
            </h1>
            <div className={s.authPage__body}>
                <div className={s.authPage__tabs}>
                    <TabItems />
                    {router.pathname === LinksEnum.SIGN_IN_ERROR && (
                        <div className={s.authPage__error}>{tr({ id: 'error.default' })}</div>
                    )}
                </div>
                <Input
                    boxClassName={s.authPage__input}
                    label={tr({ id: 'auth.page.email.input.label' })}
                    placeholder={tr({ id: 'auth.page.email.input.placeholder' })}
                    name={'email'}
                    type={'email'}
                    value={email}
                    description={{
                        error: !valid,
                        text: tr({ id: valid ? 'doublecheck.your.email' : 'auth.page.incorrectly.email' }),
                    }}
                    onPrint={changeEmailHandler}
                    autoComplete={'email'}
                />
                <Button
                    id='auth_continue_button'
                    className={s.authPage__button}
                    size={'large'}
                    color={'Black'}
                    onClick={emailHandler}
                    disabled={valid !== true || !isChecked}
                >
                    {tr({ id: 'btn.continue' })}
                </Button>
                <Checkbox
                    boxClassName={s.authPage__checkbox}
                    name={'terms_and_policy'}
                    checked={isChecked}
                    onChange={() => {
                        setIsChecked((prev) => !prev)
                    }}
                    label={
                        <FormattedMessage
                            id='auth.page.checkbox.label'
                            values={{
                                privacy: (str) => (
                                    <Link
                                        className={s.authPage__link}
                                        href={LinksEnum.PRIVACY}
                                        target={'_blank'}
                                        rel={'no-referrer'}
                                    >
                                        {str}
                                    </Link>
                                ),
                                terms: (str) => (
                                    <Link
                                        className={s.authPage__link}
                                        href={LinksEnum.TERMS}
                                        target={'_blank'}
                                        rel={'no-referrer'}
                                    >
                                        {str}
                                    </Link>
                                ),
                            }}
                        />
                    }
                    labelClassName={s.authPage__checkboxLabel}
                />
            </div>
            <div className={s.authPage__socials}>
                <Socials
                    isChecked={isChecked}
                />
            </div>
            <Button
                id='auth_having_trouble_button'
                className={s.authPage__support}
                size={'medium'}
                color={'Transparent'}
                onClick={supportHandler}
            >
                {tr({ id: 'auth.page.having.trouble' })}
            </Button>
        </>
    )
}
